import {
  Button,
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyTitle
} from 'design-system';
import { useNavigate } from 'react-router';

export const SharedDashboardNotFound = () => {
  const navigate = useNavigate();

  return (
    <Empty className='min-h-[60vh]'>
      <EmptyHeader>
        <EmptyTitle className='text-xl'>This dashboard is no longer available</EmptyTitle>
        <EmptyDescription>Let's create a new one</EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <Button
          onClick={() => {
            navigate('/dashboard');
          }}
        >
          Go to My Dashboard
        </Button>
      </EmptyContent>
    </Empty>
  );
};
